module.exports = __webpack_public_path__ + "img/frico-img5.29eec2fd.png";